import { InstantSearchServerState, InstantSearchSSRProvider } from "react-instantsearch";
import isSSR from "../isSSR";
import React from "react";

const ALGOLIA_STATE_VAR_NAME = "__ALGOLIA_STATE__";

export const wrapWithAlgoliaSSR = (Component) => ({
  algoliaState,
}: {
  algoliaState: InstantSearchServerState;
}) => {
  const state = isSSR() ? algoliaState : window[ALGOLIA_STATE_VAR_NAME];
  return (
    <InstantSearchSSRProvider {...state}>
      <Component />
    </InstantSearchSSRProvider>
  );
};

export const getAlgoliaStateScript = (algoliaState: InstantSearchServerState) => {
  if (!algoliaState) return "";

  const encodedState = JSON.stringify(algoliaState).replace(/</g, "\\u003c");

  return `
      <script>
        window.${ALGOLIA_STATE_VAR_NAME} = ${encodedState};
      </script>
    `;
};
